import React from 'react';
import { FaLinkedinIn, FaInstagram, FaTwitter } from 'react-icons/fa';
import logo from '../assets/white svnate.png'; 

const Footer = ({ openLegalModal }: { openLegalModal: (page: string) => void }) => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id: string) => {
    const element = document.querySelector(id);
    if (element) {
      const navHeight = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  return (
    <footer className="bg-svnate-darkNavy relative pt-24 pb-12 px-6 md:px-12 z-10 bg-background/50  border-t border-white/10 mt-20">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand Column */}
          <div className="flex flex-col items-start">
            <a href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('#home'); }} className="cursor-pointer">
              <img 
                src={logo} 
                alt="SVNATE Logo"
                className="h-8 w-auto object-contain mb-6 hover:opacity-80 transition-opacity duration-300"
              />
            </a>
            <p className="text-sm font-medium leading-relaxed text-foreground/70 mb-8">
              SVNATE is a premier digital agency specializing in scalable web applications, mobile apps, and custom business software solutions.
            </p>
            <div className="flex gap-4">
              <a href="https://linkedin.com/company/svnate" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-[#0f1419] border border-white/10 flex items-center justify-center hover:bg-white/20 hover:scale-110 transition-all duration-300 group">
                {React.createElement(FaLinkedinIn as any, { size: 18, className: "text-white group-hover:text-svnate-lightTeal transition-colors" })}
              </a>
              <a href="https://instagram.com/svnate.official" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-[#0f1419] border border-white/10 flex items-center justify-center hover:bg-white/20 hover:scale-110 transition-all duration-300 group">
                {React.createElement(FaInstagram as any, { size: 18, className: "text-white group-hover:text-svnate-lightTeal transition-colors" })}
              </a>
              <a href="https://twitter.com/svnate_official" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-[#0f1419] border border-white/10 flex items-center justify-center hover:bg-white/20 hover:scale-110 transition-all duration-300 group">
                {React.createElement(FaTwitter as any, { size: 18, className: "text-white group-hover:text-svnate-lightTeal transition-colors" })}
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-6 text-white/90">Explore</h4>
            <ul className="space-y-3 text-sm font-medium text-foreground/70">
              {['Home', 'Services', 'Portfolio', 'Process', 'FAQ'].map((item) => (
                <li key={item}>
                  <a 
                    href={`#${item.toLowerCase()}`} 
                    onClick={(e) => { e.preventDefault(); scrollToSection(`#${item.toLowerCase()}`); }} 
                    className="hover:text-white hover:translate-x-1 inline-block transition-all duration-300"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-6 text-white/90">Capabilities</h4>
            <ul className="space-y-3 text-sm font-medium text-foreground/70">
              <li>Web Development</li>
              <li>Mobile Applications</li>
              <li>Custom SaaS Solutions</li>
              <li>UI/UX Design</li>
              <li>Cloud Architecture</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-6 text-white/90">Connect</h4>
            <ul className="space-y-3 text-sm font-medium text-foreground/70">
              <li>
                <a href="mailto:support@svnate.com" className="hover:text-white transition-colors">support@svnate.com</a>
              </li>
              <li>
                <p>Pune, Maharashtra, India</p>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-sm font-medium text-foreground/50">
            &copy; {currentYear} SVNATE. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm font-medium text-foreground/50">
            <button onClick={() => openLegalModal('privacy')} className="hover:text-white transition-colors focus:outline-none">Privacy Policy</button>
            <button onClick={() => openLegalModal('terms')} className="hover:text-white transition-colors focus:outline-none">Terms of Service</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
